module.exports = __webpack_public_path__ + "media/images/RSD22_060_0112a-3db34f2067dc87b20e43fd2abe66c7cf.jpg";